// src/screens/admin/filesAndNotes/FilesAndNotes.js
import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Badge, Modal, Form, Table, InputGroup } from 'react-bootstrap';
import AdminLayout from '../../../layouts/admin/adminlayout/AdminLayout';
import '../../../assets/css/admin/filesAndNotes/FilesAndNotes.css';
import AppContext from '../../../context/AppContext';
import axios from 'axios';

const FilesAndNotes = () => {
  const { baseUrl, loggedInAdmin } = useContext(AppContext);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [viewType, setViewType] = useState('grid'); // grid or list
  const [filterType, setFilterType] = useState('all');
  const [fileName, setFileName] = useState('');
  const [chstudygroup_id, setchStudyGroup_id] = useState('');
  const [studySession_id, setStudySession_id] = useState('');
  const [studySessions, setStudySessions] = useState([]);
  const [studyGroup, setStudyGroup] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editId, setEditId] = useState(null);


  const [files, setFiles] = useState([]);
  const uploadFile = () => {
    const formData = new FormData();

    formData.append('file', selectedFile);
    formData.append('fileName', selectedFile.name);
    formData.append('chstudygroup_id', chstudygroup_id);
    formData.append('chstudysession_id', studySession_id);
    formData.append('chsubadmin_id', loggedInAdmin.id);
    console.log(formData);
    axios.post(`${baseUrl}/admin/fileNotes/uploadFileAndNotes`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

      .then((response) => {
        console.log(response.data);
        setShowUploadModal(false);
        viewAllFilesAndNotes();
      }
      )
      .catch((error) => {
        console.error(error);
      })
  };



  const viewAllFilesAndNotes = () => {
    axios.post(`${baseUrl}/admin/fileNotes/viewAllFilesAndNotes`)
      .then((response) => {
        console.log(response.data);
        setFiles(response.data.fileAndNotes);
      })
      .catch((error) => {
        console.error(error);
      })
  };

  const viewAllStudyGroups = () => {
    axios.post(`${baseUrl}/admin/studygroup/viewAllStudyGroups`)
      .then((response) => {
        console.log(response.data);
        setStudyGroup(response.data.studygroups);
      })
      .catch((error) => {
        console.error(error);
      })
  };

  const downloadFile = (fileId, originalFileName) => {
  axios.post(
    `${baseUrl}/admin/fileNotes/downloadFileAndNotes`,
    { id: fileId },
    { responseType: 'blob' }
  )
  .then((response) => {

    const blob = new Blob([response.data], {
      type: response.headers['content-type']
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = originalFileName;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  })
  .catch((error) => {
    console.error('Download error:', error);
  });
};
  const viewAllStudySessions = () => {
    axios.post(`${baseUrl}/admin/studySessions/viewAllStudySessions`)
      .then((response) => {
        console.log(response.data);
        setStudySessions(response.data.studySessions);
      })
      .catch((error) => {
        console.error(error);
      })
  };
  const updateFileAndNotes = (id) => {
    const formData = new FormData();
    formData.append('id', editId);
    formData.append('file', selectedFile);
    formData.append('fileName', fileName);
    formData.append('chstudygroup_id', chstudygroup_id);
    formData.append('chstudysession_id', studySession_id);
    formData.append('chsubadmin_id', loggedInAdmin.id);

    axios.post(`${baseUrl}/admin/fileNotes/updateFileAndNotes`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        setShowUploadModal(false);
        setEditId(null);
        viewAllFilesAndNotes();
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const handleEditFile = (file) => {
    setEditId(file.id);
    setFileName(file.fileName);
    setchStudyGroup_id(file.chstudygroup_id);
    setStudySession_id(file.chstudysession_id);
    setShowUploadModal(true);
  };

  const getFileIcon = (type) => {
    switch (type) {
      case 'pdf': return '📄';
      case 'doc': return '📝';
      case 'video': return '🎥';
      case 'ppt': return '📊';
      case 'image': return '🖼️';
      default: return '📁';
    }
  };

  const getFileColor = (type) => {
    switch (type) {
      case 'pdf': return 'danger';
      case 'doc': return 'primary';
      case 'video': return 'warning';
      case 'ppt': return 'success';
      case 'image': return 'info';
      default: return 'secondary';
    }
  };

  const handleDeleteFile = (id) => {
    if (window.confirm('Are you sure you want to delete this file?')) {
      axios.post(`${baseUrl}/admin/fileNotes/deleteFileAndNotes`, {
        id: id
      })
        .then((response) => {
          console.log(response.data);
          viewAllFilesAndNotes();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };


  useEffect(() => {
    viewAllFilesAndNotes();
    viewAllStudyGroups();
    viewAllStudySessions();
  }, []);

  return (
    <AdminLayout>
      <div className="files-notes-page">
        {/* Page Header */}
        <div className="page-header mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="page-title">
                <span className="page-icon">📂</span>
                Files & Notes Management
              </h2>
              <p className="text-muted">Upload and manage study materials</p>
            </div>
            <Button variant="primary" size="lg" className="add-file-btn" onClick={() => setShowUploadModal
              (true)}>
              Upload File
            </Button>
          </div>
        </div>

        {/* Stats Cards */}
        <Row className="mb-4">
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-blue">
              <Card.Body>
                <div className="stat-icon">📁</div>
                <div className="stat-info">
                  <h3>{files.length}</h3>
                  <p>Total Files</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-red">
              <Card.Body>
                <div className="stat-icon">📄</div>
                <div className="stat-info">
                  <h3>{files.length}</h3>
                  <p>PDF Documents</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-orange">
              <Card.Body>
                <div className="stat-icon">🎥</div>
                <div className="stat-info">
                  <h3>{files.length}</h3>
                  <p>Video Files</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-green">
              <Card.Body>
                <div className="stat-icon">⬇️</div>
                <div className="stat-info">
                  {/* <h3>{files.reduce((sum, f) => sum + f.downloads, 0)}</h3> */}
                  <p>Total Downloads</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Filters & View Toggle */}
        <Card className="mb-4">
          <Card.Body>
            <Row className="align-items-center">
              <Col lg={4} className="mb-3 mb-lg-0">
                <InputGroup>
                  <InputGroup.Text>
                    <i className="bi bi-search"></i>
                  </InputGroup.Text>
                  <Form.Control type="text" placeholder="Search files..." />
                </InputGroup>
              </Col>
              <Col lg={3} className="mb-3 mb-lg-0">
                <Form.Select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                  <option value="all">All Types</option>
                  <option value="pdf">PDF</option>
                  <option value="doc">Documents</option>
                  <option value="video">Videos</option>
                  <option value="ppt">Presentations</option>
                  <option value="image">Images</option>
                </Form.Select>
              </Col>
              <Col lg={3} className="mb-3 mb-lg-0">
                <Form.Select>
                  <option>All Categories</option>
                  <option>Programming</option>
                  <option>Mathematics</option>
                  <option>Science</option>
                </Form.Select>
              </Col>
              <Col lg={2}>
                <div className="view-toggle">
                  <Button
                    variant={viewType === 'grid' ? 'primary' : 'outline-secondary'}
                    size="sm"
                    onClick={() => setViewType('grid')}
                  >
                    <i className="bi bi-grid-3x3"></i>
                  </Button>
                  <Button
                    variant={viewType === 'list' ? 'primary' : 'outline-secondary'}
                    size="sm"
                    onClick={() => setViewType('list')}
                  >
                    <i className="bi bi-list"></i>
                  </Button>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card>
          <Card.Body>
            <Table hover responsive>
              <thead>
                <tr>
                  <th>File Name</th>
                  <th>Study Group</th>
                  <th>Session</th>
                  <th>Uploaded By</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {files.map((file) => (
                  <tr key={file.id}>
                    <td>
                      <div className="d-flex align-items-center">
                        <span className="file-icon-small me-2">{getFileIcon(file.type)}</span>
                        <span>{file.fileName}</span>
                      </div>
                    </td>
                    <td>{file.chstudygroup.groupName}</td>
                    <td>{file.chstudysession?.sessionTitle}</td>
                    <td>{file.chsubadmin?.name}</td>

                    <td>
                      <div className="d-flex gap-1">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => downloadFile(file.id, file.fileName)}
                        >
                          <i className="bi bi-download"></i>
                        </Button>

                        <Button variant="outline-warning" size="sm"
                          onClick={() => handleEditFile(file)}>
                          <i className="bi bi-pencil"></i>
                        </Button>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleDeleteFile(file.id)}
                        >
                          <i className="bi bi-trash"></i>
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>

        {/* Upload File Modal */}
        <Modal show={showUploadModal} onHide={() => setShowUploadModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Upload File</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>File Upload</Form.Label>
                <Form.Control type="file" onChange={(e) => setSelectedFile(e.target.files[0])} />
                <Form.Text className="text-muted">
                  Supported formats: PDF, DOC, DOCX, PPT, PPTX, MP4, PNG, JPG (Max 200MB)
                </Form.Text>
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>File Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter file name"
                      value={fileName}
                      onChange={(e) => setFileName(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Assign to Study Group</Form.Label>
                    <Form.Select
                      value={chstudygroup_id}
                      onChange={(e) => setchStudyGroup_id(e.target.value)}
                    >

                      <option>Select study group</option>
                      {studyGroup.map((group) => (
                        <option key={group.id} value={group.id}>{group.groupName}</option>
                      ))}

                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Assign to Study Session</Form.Label>
                    <Form.Select
                      value={studySession_id}
                      onChange={(e) => setStudySession_id(e.target.value)}
                    >

                      <option>Select Study Session</option>
                      {studySessions.map((session) => (
                        <option key={session.id} value={session.id}>{session?.sessionTitle}</option>
                      ))}

                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Form>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowUploadModal(false)}>Cancel</Button>
            <Button
              variant="primary"
              onClick={editId ? () => updateFileAndNotes(editId) : uploadFile}
            >
              {editId ? "Update File" : "Upload File"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </AdminLayout>
  );
};

export default FilesAndNotes;